import React from 'react'

const TermAndCondition = () => {
    return (
        <div>
            <h2 className="font-bold text-xl mb-4">Terms & Conditions</h2>
            <p>
                Welcome to our website. By accessing or using our platform, you agree to comply with the following Terms and Conditions. These terms govern your use of our services, purchases, and interactions with our platform. If you do not agree, please do not continue using our website.
            </p>
            <p>
                All products and services are subject to availability. We reserve the right to refuse service, cancel orders, or update product details without prior notice. Prices may change due to market conditions, promotions, or errors in listing.
            </p>
            <p>
                You are responsible for maintaining the confidentiality of your account details. Any misuse, fraudulent activity, or violation of these terms may result in suspension or termination of your account.
            </p>
            <p>
                The company shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. These terms are governed by applicable laws, and disputes will be subject to the jurisdiction of relevant courts.
            </p>
        </div>

    )
}

export default TermAndCondition